// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loader":"X3HrF","rotate":"L17ct"};